<template>
  
    <el-container>
     
      <el-main>
       <h1>价格</h1>

       <table>
<thead>
<tr>
<th>免费</th>
<th>催化剂</th>
</tr>
</thead>
<tbody>
<tr>
<td><code>basic</code>模式的思维导图</td>
<td>思维导图所有功能</td>
</tr>
<tr>
<td>一些 <code>rich</code> 模式功能</td>
<td>PDF/EPUB 标注功能</td>
</tr>
<tr>
<td>大纲模式</td>
<td>支持开发者</td>
</tr>
<tr>
<td>支持全平台</td>
<td>支持全平台</td>
</tr>
<tr>
<td>￥0</td>
<td>￥80 （永久）</td>
</tr>
<tr>
<td></td>
<td><a href="https://www.markmind.net/cn" rel="nofollow">购买</a></td>
</tr>
</tbody>
</table>

<h4>你可以 <i>免费使用一个月</i>，之后需要购买激活码，并在设置页面填入激活码用以激活软件</h4>

<h3>如何激活移动版 ?</h3>
<ol>
    <li>打开一个思维导图</li>
    <li>在电脑版设置页面填入购买的激活码</li>
    <li>重启obsidain，检查设置页面，将会自动生成移动端激活码</li>
    <li>复制并粘贴到手机版</li>
</ol>



      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'PricePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
